export default __webpack_public_path__ + "static/media/paper_charts.0c1a82e5.jpg";